
import Vue from 'vue';
import axios from 'axios';
import CSV from '@/components/templates/CSV.vue';
import CopyButton from '@/components/templates/CopyButton.vue';
import Top from '@/components/templates/Top.vue';
import CorpDetail from './CorpDetail.vue';

import { mapActions, mapGetters } from 'vuex';

import i18n from '@/plugins/i18n';
import * as views from '@/plugins/utils/View';
import * as crud from '@/plugins/utils/Crud';
import * as action from '@/store/actions';
import { Corp, View } from '@/types/conf';
import { getCookie, setCookie } from '@/plugins/utils/cookieManager';
import msgCodes from '@/extendedFunctions/msgCodes';

export default Vue.extend({
  name: 'Corps',
  data: () => ({
    canDelete: false,
    canCreate: false,
    canUpdate: false,
    corpCache: [] as Corp[],
    ipDialog: false,
    ipAddress: null,

    computedItems: screen.width < 600 ? 1 : 10,
    computedHeight: screen.width < 600 ? 48 * 12.2 : 48 * 11,

    alertType: '',
    alertMessage: '',
    corpList: [] as Corp[],
    selectedCorp: null as Corp | null,
    checkbox: [] as any[],
    search: '',
    dialog: false,
    dialogDelete: false,
    dialogDeleteMeet: false,
    loadingList: false,
  }),
  computed: {
    ...mapGetters({
      views: 'auth/views',
      user: 'auth/user',
      checkCorp: 'auth/checkCorp',
      softwareId: 'auth/softwareId',
      hoverColor: 'lookAndFeel/hoverColor',
      menuIconColor: 'lookAndFeel/menuIconColor',
      menuFontColor: 'lookAndFeel/menuFontColor',     
    }),

    computedCorpList() {
      this.corpCache = this.corpList.map((el : Corp) => ({
        ...el,
        enabled: el.enabled === 1 ? i18n.t('misc.yes') : i18n.t('misc.no'),
        monEnabled: el.monEnabled === 1 ? i18n.t('misc.yes') : i18n.t('misc.no'),
      }));
      return this.corpCache;
    },
  },
  async mounted() {
    console.log(this.checkCorp);
  this.loadingList = true;
  this.corpList = await this.getCorpList(action.CORP_CONTROLLER);
  await this.fetchRoomEnabledStatus();
  this.loadingList = false;
  this.initializeUserLevelData();
  this.actionHandler();
},
  components: {
    CopyButton,
    CSV,
    Top,
    CorpDetail,
  },

  methods: {
    ...mapActions({
      getCorpList: 'crudService/getList',
      deleteCorp: 'crudService/deleteObjectWithData',
    }),
    async fetchRoomEnabledStatus(){
        for (let corp of this.corpList) {
        try {
          const response = await axios.get('https://apimeet.voipgroup.com:4000/corps/corps/permitRooms', {
            params: { corpId: corp.id, softwareId: this.softwareId }
            //params: { corpId: corp.id, softwareId: 2 }
          });
          this.$set(corp, 'roomEnabled', !!response.data.exist);
        } catch (error) {
          console.error(`Error fetching room enabled status for corp ${corp.id}:`, error);
          this.$set(corp, 'roomEnabled', false);
        }
      }
    },
    async cancelDeleteMeet(){
      this.dialogDeleteMeet = false
      this.currentItem.roomEnabled = true;
    },
    initializeUserLevelData() {
      if (this.user.level === 1) {
        this.checkbox = this.corpList.filter((item) => {
          return item.id === this.user.corpId;
        });
        const cookie = getCookie('selectedCorpId');
        this.checkbox = [this.corpList.find((corp) => corp.id == parseInt(cookie || '0'))];
      }
    },
    async onCheckRoomChange(item: Corp, newValue: boolean) {
      this.currentItem = item
      if(newValue)
      {
        this.ipDialog = true
        var response = await axios.post("https://apimeet.voipgroup.com:4000/corps",{
          corpId: item.id, 
          corpName: item.name,
          softwareId: this.softwareId
        })
      }
      else
      {
        this.dialogDeleteMeet = true;
      }
    },
    async deleteCorpMeet(){
      await axios.delete("https://apimeet.voipgroup.com:4000/corps/corps",{
          //params: { corpIdDelete: this.corp.id, softwareId: 2}
          params: { corpId: this.currentItem.id, softwareId: this.softwareId}
        })
      this.dialogDeleteMeet = false;
    },
    headers() {
      return [
        {
          text: i18n.t('misc.actions'),
          value: 'actions',
          sortable: false,
          width: '100px',
        },
        {
          text: 'ID',
          value: 'id',
          width: '70px',
        },
        {
          text: i18n.t('misc.name'),
          value: 'name',
        },
        {
          text: i18n.t('misc.enabled'),
          value: 'enabled',
          width: '110px',
        },
        {
          text: i18n.t('corp.extLen'),
          value: 'extLen',
          width: '110px',
        },
        {
          text: i18n.t('corp.extMax'),
          value: 'extMax',
          width: '150px',
        },
        {
          text: i18n.t('corp.queueMax'),
          value: 'queMax',
          width: '150px',
        },
        {
          text: i18n.t('corp.monEnabled'),
          value: 'monEnabled',
          width: '160px'
        },
        {
          text: i18n.t('corp.allowCustom'),
          value: 'allowCustom',
          width: '150px',
        },
        {
          text: i18n.t('misc.maxContacts'),
          value: 'maxContacts',
          width: '110px',
        },
        {
          text: i18n.t('misc.user'),
          value: 'usersInCorp',
          width: '100px',
        },
        ...(this.softwareId != -10
          ? [
              {
                text: i18n.t('misc.checkRoom'),
                value: 'checkRoom',
                width: '100px',
                sortable: false
              },
            ]
          : []),
      ];  
    },
    csvHeaders() {
      return [
        {
          text: i18n.t('misc.actions'),
          value: 'actions',
          sortable: false,
          width: '100px',
        },
        {
          text: 'ID',
          value: 'id',
          width: '70px',
        },
        {
          text: i18n.t('misc.name'),
          value: 'name',
        },
        {
          text: i18n.t('misc.enabled'),
          value: 'enabled',
        },
        {
          text: i18n.t('corp.extLen'),
          value: 'extLen',
        },
        {
          text: i18n.t('corp.extMax'),
          value: 'extMax',
        },
        {
          text: i18n.t('corp.queueMax'),
          value: 'queMax',
        },
        {
          text: i18n.t('corp.monEnabled'),
          value: 'monEnabled',
        },
        {
          text: i18n.t('corp.monPath'),
          value: 'monPath',
        },
        {
          text: i18n.t('corp.allowCustom'),
          value: 'allowCustom',
        },
        {
          text: i18n.t('misc.maxContacts'),
          value: 'maxContacts',
        },
      ];
    },

    actionHandler() {
      const view = this.views.find((v: View) => v.name == views.CORP);
      if (view) {
        this.canDelete = view.actions.includes(crud.DELETE);
        this.canCreate = view.actions.includes(crud.CREATE);
        this.canUpdate = view.actions.includes(crud.UPDATE);
      }
    },
    editItem(item: Corp) {
      this.navigateTo(item);
    },

    deleteItem(item: Corp) {
      this.selectedCorp = item;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      const response = await this.deleteCorp({
        action: action.CORP_CONTROLLER,
        id: this.selectedCorp?.id,
      });
      
      // This set if the form must persist or don't
      this.dialogDelete = response >= 400;

      this.alertMessage = msgCodes(response.status, false).alertMessage;
      this.alertType = msgCodes(response.status, false).alertType;

      this.$store.dispatch('snackbar/showSnack', {
        message: this.alertMessage,
        color: this.alertType,
        timeout: 3000,
      });

      this.refreshList();
    },

    handleCorpSelect(e: any) {
      // If selected
      if (e.value) {
        setCookie('selectedCorpId', e.item.id.toString(), 1);
        setCookie('selectedCorpName', e.item.name.toString(), 1);

        this.$router.replace({ name: 'home' });
      }
      else{
        setCookie('selectedCorpId', "0", 1);
        setCookie('selectedCorpName', null, 1);

        this.$router.replace({ name: 'home' });
      }
      this.$store.dispatch('lookAndFeel/checkLookandfeel');
    },
    navigateTo(corp: any = false) {
      if (corp === 'users') {
        this.$router.replace({
          name: 'user',
        });
      } else {
        if (corp) {
          this.$router.replace({
            name: 'corp/update',
            params: { corpToUpdate: corp },
          });
        } else {
          this.$router.replace({
            name: 'corp/new',
          });
        }
      }
    },

    async refreshList() {
      this.loadingList = true;
      this.corpList = await this.getCorpList(action.CORP_CONTROLLER);
      await this.fetchRoomEnabledStatus();
      // Marca en el chekbox el cambio de corpo a travez de la cookie, por ahora no lo usamos
      if (this.user.level === 1) {
        this.checkbox = this.corpList.filter((item) => {
          return item.id === this.user.corpId;
        });
        const cookie = getCookie('selectedCorpId');

        this.checkbox = [
          this.corpList.find((corp) => corp.id == parseInt(cookie || '0')),
        ];
      }
      this.actionHandler();
      this.loadingList = false;
    },
  },
});
